import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "base",
    component: () => import("../views/base/index.vue"),
    children: [
      {
        path: "/",
        name: "index",
        meta: {
          name: "天津市医药流通行业信息化平台",
          nav: true,
          bg:'',
          selbg:''
        },
        component: () => import("../views/index/index.vue"),
      },
    ],
  },

];

const router = new VueRouter({
  routes,
});

export default router;
